const normalizeEnvValue = (value) => {
	if (typeof value !== "string") return "";
	const trimmed = value.trim();
	return trimmed.length > 0 ? trimmed : "";
};

const trimTrailingSlashes = (value) => value.replace(/\/+$/, "");

const isLocalBrowserHost = () => {
	if (typeof window === "undefined") return false;
	const host = window.location?.hostname ?? "";
	return host === "localhost" || host === "127.0.0.1" || host === "::1";
};

const resolveByHost = (localValue, remoteValue) => {
	const local = normalizeEnvValue(localValue);
	const remote = normalizeEnvValue(remoteValue);

	if (isLocalBrowserHost()) {
		return local || remote;
	}

	return remote || local;
};

const resolveApiBaseUrl = () => {
	const explicit = normalizeEnvValue(process.env.REACT_APP_API_BASE_URL);
	if (explicit) return explicit;

	const byHost = resolveByHost(
		process.env.REACT_APP_LINK_LOCAL,
		process.env.REACT_APP_LINK,
	);

	return byHost || "http://localhost:5067/api";
};

const resolveFileBaseUrl = () => {
	const explicit = normalizeEnvValue(process.env.REACT_APP_FILE_BASE_URL);
	if (explicit) return explicit;

	const byHost = resolveByHost(
		process.env.REACT_APP_FILE_PATH_LOCAL,
		process.env.REACT_APP_FILE_PATH,
	);

	return byHost || "http://localhost:5067/Resources";
};

export const API_BASE_URL = trimTrailingSlashes(resolveApiBaseUrl());
export const FILE_BASE_URL = trimTrailingSlashes(resolveFileBaseUrl());
